import React from 'react';

import { List } from './List';
import { Edit } from './Edit';

export const hotelsSampleRoutes = {
  path: '/hotelsSample',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit slug='/hotelsSample' />,
    },
    {
      path: 'add',
      element: <Edit slug='/hotelsSample' />,
    },
  ],
};
